<div class="search-overlay" role="dialog" aria-label="Búsqueda global">
  <!-- Header fijo -->
  <div class="search-overlay-header">
    <div class="search-input-row">
      <i class="icon-magnifier search-icon" aria-hidden="true"></i>
      <input #searchInput
        [(ngModel)]="searchText"
        type="text"
        class="search-overlay-input"
        [placeholder]="'buttons.orders-filter' | translate"
        aria-label="Buscar"
        autocomplete="off"
        maxlength="100" />
      <button *ngIf="searchText" type="button" class="btn-clear" (click)="clearSearch()" aria-label="Limpiar búsqueda">
        <i class="icon-close" aria-hidden="true"></i>
      </button>
      <button type="button" class="btn-close-overlay" (click)="close()" aria-label="Cerrar búsqueda">
        {{ 'buttons.cancel' | translate }}
      </button>
    </div>
  </div>

  <!-- Resultados scrollables -->
  <div class="search-overlay-results">
    <!-- Loading -->
    <div *ngIf="isSearching" class="search-state">
      <i class="icon-magnifier search-state-icon" aria-hidden="true"></i>
      <span>{{ 'buttons.searching' | translate }}...</span>
    </div>

    <!-- Error -->
    <div *ngIf="errorMessage && !isSearching" class="search-state search-state-error">
      <i class="icon-close search-state-icon" aria-hidden="true"></i>
      <span>{{ 'errors.generic' | translate }}</span>
    </div>

    <!-- Sin resultados -->
    <div *ngIf="hasSearched && !hasResults && !isSearching && !errorMessage" class="search-state">
      <i class="icon-magnifier search-state-icon" aria-hidden="true"></i>
      <span>{{ 'buttons.no-results' | translate }}</span>
    </div>

    <!-- Resultados agrupados -->
    <ng-container *ngFor="let group of searchSuggestions">
      <ng-container *ngFor="let key of objectKeys(group)">
        <div class="result-group" *ngIf="group[key]?.items?.length">
          <div class="result-group-header">
            <i class="{{ group[key].icon }}" aria-hidden="true"></i>
            <span>{{ "titles-menu-pages."+key | lowercase | translate | titlecase }}</span>
            <span class="result-count">({{ group[key].items.length }})</span>
          </div>
          <a *ngFor="let item of group[key].items"
            class="result-item"
            (click)="onResultClick(item.link)"
            role="button"
            tabindex="0">
            <span>{{ item.data }}</span>
            <i class="icon-chevron-right result-chevron" aria-hidden="true"></i>
          </a>
        </div>
      </ng-container>
    </ng-container>

    <!-- Estado inicial -->
    <div *ngIf="!hasSearched && !isSearching" class="search-state search-state-initial">
      <i class="icon-magnifier search-state-icon" aria-hidden="true"></i>
      <span>{{ 'buttons.orders-filter' | translate }}</span>
    </div>
  </div>
</div>
